import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material';
import { MensajeSnackBarComponent } from '../../components/shared/mensaje-snack-bar/mensaje-snack-bar.component';


@Injectable()
export class MensajeSnackBarService {

  constructor(public snackBar: MatSnackBar) { }

  mostrarMensaje(mensaje: String) {
    this.snackBar.openFromComponent(MensajeSnackBarComponent, {
      data: mensaje,
      duration: 7000
    });
  }

  mostrarMensajeWithPosition(mensaje: String, horizontalPosition, verticalPosition) {
    this.snackBar.openFromComponent(MensajeSnackBarComponent, {
      data: mensaje,
      duration: 7000,
      horizontalPosition: horizontalPosition,
      verticalPosition: verticalPosition
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/services/mensaje-snack-bar/mensaje-snack-bar.service.ts